module.exports = __webpack_public_path__ + "static/media/arrows.a5442f36.svg";